module.exports = __webpack_public_path__ + "img/digitization-network.ded36d94.svg";